import React from 'react'
import { Classes, Position } from '@blueprintjs/core'
import { Button, Popover } from '@ui'

type Props = {
  value: string
  colors: string[]
  onChange: (value: string) => void
  buttonStyle?: React.CSSProperties
  containerStyle?: React.CSSProperties
}

function SimpleColorPicker({
  value,
  colors,
  onChange,
  buttonStyle = {},
  containerStyle = {},
}: Props) {
  return (
    <div style={containerStyle}>
      <Popover
        minimal
        position={Position.BOTTOM}
        popoverClassName={Classes.POPOVER_DISMISS}
        content={
          <div style={{ padding: 5, display: 'flex', flexWrap: 'wrap', maxWidth: 114 }}>
            {colors.map((color) => (
              <div
                key={color}
                onClick={() => onChange(color)}
                style={{
                  backgroundColor: color,
                  width: 16,
                  height: 16,
                  margin: 5,
                  cursor: 'pointer',
                }}
              />
            ))}
          </div>
        }
      >
        <Button
          text={<div style={{ backgroundColor: value, width: 50, height: 18 }} />}
          style={buttonStyle}
        />
      </Popover>
    </div>
  )
}

export default SimpleColorPicker
